import { InvalidUrlError } from '../../../common/errors/errors';
import { BaseGQLService } from '../../../common/services/BaseGQLService';
import { FilterOperator, SorterSet } from '../../../common/types/gql-types';
import { CursorInfo, PaginationResult } from '../../../common/types/pagination';
import { ModelType } from '../../../common/utils/GQLIdEncoder';
import { ReportCallSiteMapper } from '../mappers/ReportCallSiteMapper';
import { ReportCallSite } from '../models/ReportCallSite';

export const GET_REPORT_CALL_SITES_QUERY = `
query(
  $reportId: ID!,
  $first: Int,
  $last: Int,
  $before: String,
  $after: String,
  $filters: CallSitesFilter,
  $sorters: [CallSitesSorter]
) {
  report: node(id: $reportId) {
      ... on ReportDone {
        callSites(
            first: $first,
            last: $last,
            before: $before,
            after: $after,
            filters: $filters,
            sorters: $sorters
        ){
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        edges {
          node {
            id
            covered
            class
            method
            file
            line
            calledClass
            calledMethod
          }
        }
        totalCount
      }
    }
  }
}
`;

export class ReportCallsSitesService extends BaseGQLService {
  private readonly callSiteMapper = new ReportCallSiteMapper();

  async getList(reportId: number, cursor: CursorInfo, filters: FilterOperator | null, sorters: SorterSet[]): Promise<PaginationResult<ReportCallSite>> {
    return this.query(
      GET_REPORT_CALL_SITES_QUERY,
      {
        reportId: this.gqlIdEncoder.encode(ModelType.Report, reportId),
        ...this.mapCursorInfo(cursor),
        filters,
        sorters,
      },
      (data) => {
        if (!data.report) {
          throw new InvalidUrlError(`Invalid request: could not find Report ${reportId}`);
        }
        const { edges, pageInfo, totalCount } = data.report.callSites;
        return {
          data: edges.map(({ node }: any) => this.callSiteMapper.mapGQLModel(node)),
          pageInfo,
          totalCount,
        };
      }
    );
  }
}
